import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { SignupComponent } from './signup.component';
import { CompleteComponent } from './complete/complete.component';
import { RegisterComponent } from './register/register.component';
import { PlatformComponent } from './platform/platform.component';
import { PlatformGuard } from './platform/signup.platform_guard';
import { RegisterGuard } from './register/signup.register_guard';
import { ProductGuard } from './product/signup.product_guard';
import { CompleteGuard } from './complete/signup.complete_guard';
import { FinishComponent } from './finish/finish.component';
import { AuthGuard } from '../app.auth_guard';
import { ActivateComponent } from './activate/activate.component';
import { ExpiredComponent } from './link_expired/expired.component';
import { ChangePasswordGuard } from './shared/change_password_guard';
import { ResetPasswordComponent } from './reset_password/reset_password.component';

const signupRoutes: Routes = [
  {
    path: 'signup',
    component: SignupComponent,
    children: [
      {
        path: 'finish',
        component: FinishComponent,
        canActivate: [AuthGuard],
      },
      {
        path: '',
        component: LayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'register',
            pathMatch: 'full'
          },
          {
            path: 'register',
            component: RegisterComponent,
            canActivate: [RegisterGuard],
          },
          {
            path: 'platform',
            component: PlatformComponent,
            canActivate: [PlatformGuard],
          },
          {
            path: 'complete',
            component: CompleteComponent,
            canActivate: [CompleteGuard],
            data: {
              inAppInstall: true
            },
          },
          {
            path: 'activate',
            component: ActivateComponent,
            canActivate: [ChangePasswordGuard],
          },
          {
            path: 'reset_password',
            component: ResetPasswordComponent,
            canActivate: [ChangePasswordGuard],
          },
          {
            path: 'link_expired',
            component: ExpiredComponent
          }
        ]
      }
    ]

  }
];

@NgModule({
  imports: [
    RouterModule.forChild(signupRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [RegisterGuard, PlatformGuard, ProductGuard, CompleteGuard, ChangePasswordGuard]
})

export class SignupRoutingModule {}
